import React from 'react';
import heroImageMobile from '../../../assets/images/home_page_mobile_img_1.svg';
import heroImage from '../../../assets/images/theme_2.svg';
import aboutImage from '../../../assets/images/inner_design_heading.svg';
import bgImage from '../../../assets/images/bg_img.svg';
import lineIcon from '../../../assets/images/card_line_icon.svg';
import panMasala2 from '../../../assets/images/card_image_1.svg';
import panMasala4 from '../../../assets/images/pan_masala_4_gram.svg';
import finestBg from '../../../assets/images/finest_bg.svg';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import logo from '../../../assets/images/logo_icon.svg';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import DashboardPageHelmet from '../../HelmetComponents/DashboardPageHelmet';

const Dashboard: React.FC = () => {
  useDocumentTitle('Namasteji Manikchand');
  const location = useLocation();
  console.log('Welcome TO Dashboard');
  useEffect(() => {
    const scrollTargetId = location.state?.scrollTo;

    if (scrollTargetId) {
      const el = document.getElementById(scrollTargetId);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  return (
    <>
      <DashboardPageHelmet />
      <div className='w-full'>
        {/* Hero Section */}
        <section className='relative w-full'>
          <img
            src={heroImageMobile}
            alt='Namasteji Manikchand pan masala product pouch'
            className='block md:hidden h-full w-full object-cover'
          />
          <img
            src={heroImage}
            alt='Namasteji Manikchand pan masala product pouch'
            className='hidden md:block h-full w-full object-cover'
          />
        </section>

        {/* Namasteji Manikchand Pan Masala */}
        <section className='py-6 sm:py-6 md:py-12 lg:py-12 px-4 sm:px-8 md:px-16 text-center bg-[#F8F8F8]'>
          <h1 className='font-rubik text-[26px] sm:text-[26px] md:text-[32px] lg:text-[32px] font-bold text-[#4A2D1A]'>
            Namasteji Manikchand Pan Masala
          </h1>
          <div className='flex justify-center my-0 sm:my-0 md:my-4 lg:my-4'>
            <img src={aboutImage} alt='About Us BG' className='w-4/5 md:w-2/5 max-w-full' />
          </div>
          <div className='max-w-5xl mx-auto'>
            <p className='font-poppins italic text-sm sm:text-sm md:text-lg lg:text-lg text-[#000000] leading-relaxed mt-4 text-justify'>
              Legacy of Trust, Taste, and Excellence{' '}
            </p>
            <div>
              <h2 className='font-rubik text-[18px] sm:text-[18px] md:text-[24px] lg:text-[24px] font-bold text-[#4A2D1A] text-start py-1 sm:py-1 md:py-2 lg:py-2'>
                Namasteji Manikchand Pan Masala
              </h2>

              <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg text-[#000000] leading-relaxed text-justify'>
                Namasteji Manikchand Pan Masala stands as one of India’s most trusted and respected pan masala brands,
                celebrated for its authentic taste, premium quality, and cultural heritage. With decades of excellence,
                the brand has built a legacy grounded in integrity, craftsmanship, and customer trust.
              </p>
              <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg text-[#000000] leading-relaxed text-justify mt-2 sm:mt-2 md:mt-2 lg:mt-3'>
                Our journey reflects a proud tradition of blending Indian flavors with modern manufacturing standards,
                ensuring every pack delivers purity, freshness, and satisfaction.
              </p>
            </div>

            <div>
              <h2 className='font-rubik text-[18px] sm:text-[18px] md:text-[24px] lg:text-[24px] font-bold text-[#4A2D1A] text-start mt-1 py-1 sm:py-1 md:py-2 lg:py-2'>
                Craftsmanship & Quality
              </h2>
              <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg text-[#000000] leading-relaxed text-justify'>
                Every pack of Namasteji Manikchand Pan Masala is a masterpiece crafted from handpicked ingredients and
                refined with precision. Our blends capture the true spirit of India’s traditional taste, combining
                time-tested recipes with cutting-edge hygiene and quality standards. At Namasteji Manikchand, quality
                isn’t an act it’s our identity.
              </p>
            </div>
            <div>
              <h2 className='font-rubik text-[18px] sm:text-[18px] md:text-[24px] lg:text-[24px] font-bold text-[#4A2D1A] text-start py-1 sm:py-1 md:py-2 lg:py-2 mt-1'>
                Vision for Global Recognition
              </h2>
              <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg text-[#000000] leading-relaxed text-justify'>
                Our vision is to make Namasteji Manikchand a global symbol of taste, trust, and quality. Through
                continuous innovation, premium quality control, and an uncompromising focus on consumer satisfaction, we
                aim to expand our legacy beyond borders. Namasteji Manikchand Pan Masala is not just a product it’s a
                promise of purity and excellence.
              </p>
            </div>
          </div>
        </section>

        {/* About Us Section */}
        <section className='py-6 sm:py-6 md:py-12 lg:py-12 px-4 sm:px-8 md:px-16 text-center bg-white'>
          <h2 className='font-rubik text-[26px] sm:text-[26px] md:text-[32px] lg:text-[32px] font-bold text-[#4A2D1A]'>
            ABOUT US
          </h2>
          <div className='flex justify-center my-0 sm:my-0 md:my-4 lg:my-4'>
            <img src={aboutImage} alt='About Us' className='w-4/5 md:w-2/5 max-w-full' />
          </div>
          <div className='max-w-5xl mx-auto'>
            <div>
              <h2 className='font-rubik text-[18px] sm:text-[18px] md:text-[24px] lg:text-[24px] font-bold text-[#4A2D1A] text-start py-1 sm:py-1 md:py-2 lg:py-2'>
                Legacy of Authenticity and Excellence
              </h2>

              <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg text-[#000000] leading-relaxed text-justify'>
                Founded with the vision to deliver authentic Indian flavors and unmatched quality, Namasteji Manikchand
                has become one of India’s most respected names in the pan masala industry. Our legacy is built on trust,
                innovation, and cultural heritage, reflecting a perfect balance between tradition and modernity.
              </p>
            </div>

            <div>
              <h2 className='font-rubik text-[18px] sm:text-[18px] md:text-[24px] lg:text-[24px] font-bold text-[#4A2D1A] text-start mt-1 py-1 sm:py-1 md:py-2 lg:py-2'>
                Commitment to Quality and Craftsmanship
              </h2>
              <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg text-[#000000] leading-relaxed text-justify'>
                For us, pan masala is more than a blend it’s an emotion. <br />
                From sourcing the finest ingredients to packaging the final product, every step is guided by a passion
                for perfection. <br />
                Our rigorous quality control systems ensure that every pack embodies superior taste, purity, and
                consistency, reinforcing the brand’s reputation for reliability and excellence.
              </p>
            </div>
            <div>
              <h2 className='font-rubik text-[18px] sm:text-[18px] md:text-[24px] lg:text-[24px] font-bold text-[#4A2D1A] text-start py-1 sm:py-1 md:py-2 lg:py-2 mt-1'>
                Innovation, Trust, and Global Reach
              </h2>
              <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg text-[#000000] leading-relaxed text-justify'>
                Guided by visionary leadership, Namasteji Manikchand continues to redefine industry standards. Our
                commitment to innovation and customer satisfaction has enabled us to expand across India and
                international markets. Today, millions of consumers trust our brand a name synonymous with authenticity,
                heritage, and excellence.
              </p>
            </div>
          </div>
          <p
            className='lg:pt-6 xs:pt-2 sm:pt-2 text-sm sm:text-sm md:text-lg lg:text-lg max-w-5xl mx-auto text-gray-700 leading-relaxed mt-4 text-start'
            style={{
              borderBottom: '2px solid',
              borderImageSource:
                'linear-gradient(90deg, #C79856 6.06%, #FAD983 27.27%, #DFB662 47.27%, #FAD983 72.53%, #B27F32 95.6%)',
              borderImageSlice: 1,
            }}
          ></p>

          <Link to='/about'>
            <button className='font-rubik mt-5 sm:mt-5 md:mt-12 lg:mt-12 px-10 sm:px-10 md:px-16 lg:px-16 py-2 sm:py-2 md:py-3 lg:py-3 bg-red-700 text-white rounded-xl hover:bg-red-800 transition'>
              Read More
            </button>
          </Link>
        </section>

        {/* Product Cards Section */}
        <section
          id='target-section-pan-masala'
          className='w-full py-6 sm:py-6 md:py-24 lg:py-24 px-3 sm:px-3 md:px-16 lg:px-16'
          style={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
            backgroundColor: '#F2E1BD',
          }}
        >
          <div className='max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-4 md:gap-8 lg:gap-8'>
            {/* Card 1 */}
            <div className='bg-white rounded-3xl shadow-md p-4 sm:p-6 flex flex-col items-center text-center'>
              <h3 className='text-base sm:text-xl md:text-2xl lg:text-2xl font-bold text-[#4A2D1A] mb-2 mt-2 flex'>
                <img
                  src={logo}
                  alt='Manikchand Pan Masala 2g pouch'
                  className='w-6 h-5 sm:w-6 sm:h-5 md:w-14 md:h-6 lg:w-14 lg:h-6 object-contain mt-1'
                />
                <span className='text-start px-2 font-rubik'>Manikchand Pan Masala 2 Gram</span>
              </h3>
              <img src={lineIcon} alt='Namasteji Manikchand' className='w-[95%] mb-0' />
              <img
                src={panMasala2}
                alt='Manikchand Pan Masala 2g pouch'
                className='object-contain max-w-[300px] sm:max-w-[400px] md:max-w-[500px] lg:max-w-[600px] w-full h-auto'
              />
            </div>

            {/* Card 2 */}
            <div className='bg-white rounded-3xl shadow-md p-4 sm:p-6 flex flex-col items-center text-center'>
              <h3 className='text-base sm:text-xl md:text-2xl lg:text-2xl font-bold text-[#4A2D1A] mb-2 mt-2 flex'>
                <img
                  src={logo}
                  alt='Manikchand Pan Masala 4g pouch'
                  className='w-6 h-5 sm:w-6 sm:h-5 md:w-14 md:h-6 lg:w-14 lg:h-6 object-contain mt-1'
                />
                <span className='text-start px-2 font-rubik'>Manikchand Pan Masala 4 Gram</span>
              </h3>
              <img src={lineIcon} alt='Namasteji Manikchand' className='w-[95%] mb-0' />
              <img
                src={panMasala4}
                alt='Manikchand Pan Masala 4g pouch'
                className='object-contain max-w-[300px] sm:max-w-[400px] md:max-w-[500px] lg:max-w-[600px] w-full h-auto'
              />
            </div>
          </div>
        </section>

        {/* Premium Quality Section */}
        <section className='py-6 sm:py-6 md:py-16 lg:py-16 px-4 sm:px-8 md:px-16 text-center bg-white'>
          <h2 className='text-[26px] sm:text-[26px] md:text-[32px] lg:text-[32px] font-bold text-[#4A2D1A] font-rubik'>
            PREMIUM QUALITY
          </h2>
          <div className='flex justify-center my-0 sm:my-0 md:my-4 lg:my-4'>
            <img
              src={aboutImage}
              alt='Premium Quality Manikchand'
              className='max-w-[90%] sm:max-w-[90%] md:max-w-[40%] lg:max-w-[40%] h-auto'
            />
          </div>
          <div className='max-w-5xl mx-auto'>
            <div>
              <h2 className='font-rubik text-[18px] sm:text-[18px] md:text-[24px] lg:text-[24px] font-bold text-[#4A2D1A] text-start py-1 sm:py-1 md:py-2 lg:py-2'>
                1. Sourcing the Finest Ingredients
              </h2>
              <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg text-[#000000] leading-relaxed text-justify'>
                Quality begins with selection. <br />
                We carefully choose every ingredient—betelnuts, catechu, lime, menthol, and cardamom—for purity, aroma,
                and freshness. <br />
                Our suppliers meet strict quality benchmarks, ensuring that only the finest raw materials are used in
                production.
              </p>
            </div>

            <div>
              <h2 className='font-rubik text-[18px] sm:text-[18px] md:text-[24px] lg:text-[24px] font-bold text-[#4A2D1A] text-start mt-1 py-1 sm:py-1 md:py-2 lg:py-2'>
                2. Advanced Production & Packaging
              </h2>
              <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg text-[#000000] leading-relaxed text-justify'>
                Our ISO-certified facilities combine traditional expertise with modern technology to maintain hygiene,
                consistency, and excellence. <br /> From precise blending to airtight packaging, each step ensures the
                freshness, aroma, and flavor are perfectly preserved until they reach you.
              </p>
            </div>
            <div>
              <h2 className='font-rubik text-[18px] sm:text-[18px] md:text-[24px] lg:text-[24px] font-bold text-[#4A2D1A] text-start py-1 sm:py-1 md:py-2 lg:py-2 mt-1'>
                3. Commitment to Safety & Excellence
              </h2>
              <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg text-[#000000] leading-relaxed text-justify'>
                Every batch of Namasteji Manikchand Pan Masala undergoes stringent quality tests to ensure safety,
                hygiene, and consumer satisfaction. <br /> Our dedication to excellence upholds the brand’s reputation
                and sets new benchmarks in the industry.
              </p>
            </div>
          </div>
        </section>

        {/* Finest Taste Section */}
        <section className='relative py-6 sm:py-6 md:py-16 lg:py-16 px-4 sm:px-8 md:px-16 text-center bg-white overflow-hidden'>
          <div
            className='absolute inset-0 bg-cover bg-center opacity-100'
            style={{ backgroundImage: `url(${finestBg})` }}
          ></div>
          <div className='relative z-10'>
            <h2 className='text-[26px] sm:text-[26px] md:text-[32px] lg:text-[32px] font-bold text-[#4A2D1A] font-rubik'>
              FINEST TASTE
            </h2>
            <div className='flex justify-center my-0 sm:my-0 md:my-4 lg:my-4'>
              <img
                src={aboutImage}
                alt='Finest Taste Manikchand'
                className='max-w-[90%] sm:max-w-[90%] md:max-w-[40%] lg:max-w-[40%] h-auto'
              />
            </div>
            <div className='max-w-5xl mx-auto'>
              <div>
                <h2 className='font-rubik text-[18px] sm:text-[18px] md:text-[24px] lg:text-[24px] font-bold text-[#4A2D1A] text-start py-1 sm:py-1 md:py-2 lg:py-2'>
                  1. Crafting the Perfect Flavor
                </h2>
                <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg text-[#000000] leading-relaxed text-justify'>
                  At Namasteji Manikchand, taste is an emotion that connects memories and moments.
                  <br /> Each pack is crafted to deliver a rich, authentic flavor that delights the senses and reflects
                  India’s cultural essence.
                </p>
              </div>
              <div>
                <h2 className='font-rubik text-[18px] sm:text-[18px] md:text-[24px] lg:text-[24px] font-bold text-[#4A2D1A] text-start mt-1 py-1 sm:py-1 md:py-2 lg:py-2'>
                  2. Finest Ingredients, Expert Blends
                </h2>
                <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg text-[#000000] leading-relaxed text-justify'>
                  We blend premium betelnuts, aromatic cardamom, refreshing menthol, lime, and catechu in perfect
                  harmony. <br />
                  Our flavor experts ensure that every batch maintains a distinctive and consistent taste loved by
                  millions.
                </p>
              </div>
              <div>
                <h2 className='font-rubik text-[18px] sm:text-[18px] md:text-[24px] lg:text-[24px] font-bold text-[#4A2D1A] text-start py-1 sm:py-1 md:py-2 lg:py-2 mt-1'>
                  3. Honoring Tradition, Embracing Modernity
                </h2>
                <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg text-[#000000] leading-relaxed text-justify'>
                  Rooted in Indian heritage yet inspired by modern tastes, Namasteji Manikchand blends tradition and
                  innovation. Whether shared among friends or savored solo, every pack is a celebration of taste and
                  craftsmanship.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* Finest Quality Section */}
        <section className='py-6 sm:py-6 md:py-12 lg:py-12 px-4 sm:px-8 md:px-16 text-center bg-white'>
          <h2 className='text-[26px] sm:text-[26px] md:text-[32px] lg:text-[32px] font-bold text-[#4A2D1A] font-rubik'>
            FINEST QUALITY
          </h2>
          <div className='flex justify-center my-0 sm:my-0 md:my-4 lg:my-4'>
            <img
              src={aboutImage}
              alt='Finest Quality Manikchand'
              className='max-w-[90%] sm:max-w-[90%] md:max-w-[40%] lg:max-w-[40%] h-auto'
            />
          </div>
          <div className='max-w-5xl mx-auto'>
            <div>
              <h2 className='font-rubik text-[18px] sm:text-[18px] md:text-[24px] lg:text-[24px] font-bold text-[#4A2D1A] text-start py-1 sm:py-1 md:py-2 lg:py-2'>
                1. Commitment to Excellence
              </h2>
              <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg text-[#000000] leading-relaxed text-justify'>
                From sourcing to packaging, our processes are governed by global quality standards.
                <br />
                By combining traditional artistry with advanced technology, we deliver unmatched consistency, purity,
                and flavor.
              </p>
            </div>
            <div>
              <h2 className='font-rubik text-[18px] sm:text-[18px] md:text-[24px] lg:text-[24px] font-bold text-[#4A2D1A] text-start mt-1 py-1 sm:py-1 md:py-2 lg:py-2'>
                2. Trust Through Purity and Reliability
              </h2>
              <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg text-[#000000] leading-relaxed text-justify'>
                Each product symbolizes integrity, purity, and reliability.
                <br />
                Choosing Namasteji Manikchand means choosing a brand built on honesty and authenticity, ensuring
                satisfaction in every pinch.
              </p>
            </div>
            <div>
              <h2 className='font-rubik text-[18px] sm:text-[18px] md:text-[24px] lg:text-[24px] font-bold text-[#4A2D1A] text-start py-1 sm:py-1 md:py-2 lg:py-2 mt-1'>
                3. Sustainability & Responsibility
              </h2>
              <p className='font-poppins text-sm sm:text-sm md:text-lg lg:text-lg text-[#000000] leading-relaxed text-justify'>
                Our quality philosophy extends beyond products—it includes our commitment to nature and society.
                <br />
                We follow ethical sourcing, eco-friendly production, and sustainable practices to protect the planet for
                future generations.
              </p>
            </div>
          </div>
          <Link to='/contact'>
            <button className='mt-3 sm:mt-3 md:mt-8 lg:mt-8 px-10 sm:px-10 md:px-16 lg:px-16 py-2 sm:py-2 md:py-3 lg:py-3 bg-red-700 text-white rounded-xl hover:bg-red-800 transition'>
              Contact Us
            </button>
          </Link>
        </section>
      </div>
    </>
  );
};

export default Dashboard;
